import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "profile"
}
const _hoisted_2 = { class: "flex flex-col jutify-center mt-[50%] p-2 mx-2" }
const _hoisted_3 = { class: "flex w-full flex-col" }
const _hoisted_4 = { class: "self-end text-sm" }
const _hoisted_5 = { class: "self-start text-sm" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex flex-col gap-4" }
const _hoisted_8 = { class: "w-full flex items-center justify-center" }
const _hoisted_9 = { class: "w-full flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderLicensePlateInput = _resolveComponent("OrderLicensePlateInput")!
  const _component_DbButton = _resolveComponent("DbButton")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([{
          'pb-[26px]':
            !_ctx.form.processing || _ctx.isFieldValid('license_plate', _ctx.LicensePlatform),
          'pb-0':
            !_ctx.isFieldValid('license_plate', _ctx.LicensePlatform) && _ctx.form.processing,
        }, "w-full flex flex-col items-center"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("account.required")), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("account.license_plate_message")), 1)
            ]),
            _createVNode(_component_OrderLicensePlateInput, {
              modelValue: _ctx.LicensePlatform.license_plate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.LicensePlatform.license_plate) = $event)),
              value: _ctx.LicensePlatform.license_plate,
              placeholder: _ctx.$t('account.license_plate') + '*',
              label: _ctx.$t('account.license_plate') + '*',
              ariainvalid: 
            !_ctx.isFieldValid('license_plate', _ctx.LicensePlatform) && _ctx.form.processing
              ? 'true'
              : undefined
          
            }, null, 8, ["modelValue", "value", "placeholder", "label", "ariainvalid"]),
            (
            !_ctx.isFieldValid('license_plate', _ctx.LicensePlatform) && _ctx.form.processing
          )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "text-red-500",
                  innerHTML: _ctx.$t('order.errorLicensePlate')
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DbButton, {
                class: "w-full",
                onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/')),
                variant: "secondary-solid"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("account.cancel")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_DbButton, {
                onClick: _ctx.update,
                variant: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("account.save")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}